import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotApproved = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "notApproved",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_17700",
			"data-name": "Group 17700",
			transform: "translate(12 7.519)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_13088",
					"data-name": "Path 13088",
					d: "M6,12.757V12.7A4.7,4.7,0,0,1,10.7,8h4.7",
					transform: "translate(-6 -5.651)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_13089",
					"data-name": "Path 13089",
					d: "M6,14.08v3.852",
					transform: "translate(-6 -6.971)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_13090",
					"data-name": "Path 13090",
					d: "M15,9.7l2.349-2.349L15,5",
					transform: "translate(-7.953 -5)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Group_17701",
			"data-name": "Group 17701",
			transform: "translate(2.604 7.519)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Path_13088-2",
					"data-name": "Path 13088",
					d: "M15.4,12.757V12.7A4.7,4.7,0,0,0,10.7,8H6",
					transform: "translate(-6 -5.651)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_13089-2",
					"data-name": "Path 13089",
					d: "M6,14.08v3.852",
					transform: "translate(3.395 -6.971)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Path_13090-2",
					"data-name": "Path 13090",
					d: "M17.349,9.7,15,7.349,17.349,5",
					transform: "translate(-15 -5)",
					fill: "none",
					stroke: "currentColor",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_13091",
			"data-name": "Path 13091",
			d: "M0,0H24V24H0Z",
			fill: "none"
		})
	]
});
export default SvgNotApproved;
